import React, { useMemo } from "react";
import useFetchUnprocessed from "../../../Hooks/qlp_ddpcr/useFetchUnprocessed";
import { formatBytes, formatDate } from "../../../../utils/basic";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import Spinner from "../../../common/Spinner";


const ddPcrListUnprocessed = () => {
  const fileType = "ddpcr";

  const ddpcrQuery = useFetchUnprocessed(fileType);

  const ddpcrData = ddpcrQuery?.isSuccess ? ddpcrQuery.data.data : null;
  const dataForTable = (qlpData) => qlpData?.map(item => {
    let properties = {
      "id": crypto.randomUUID(),
      "fileName": item?.Key.split('/').pop(),
      "lastModified": item?.LastModified ? formatDate(item?.LastModified) : "",
      "size": formatBytes(item?.Size),
      "Size": item?.Size
    };
    return properties;
  });

  const data = useMemo(() => {
    return dataForTable(ddpcrData);
  }, [ddpcrData]);

  const cols = [
    {
      field: 'fileName',
      headerName: 'File Name',
      description: 'Name of the File',
      width: 750
    },
    {
      field: 'lastModified',
      headerName: 'Last Modified',
      description: 'last modified date time',
      width: 450
    },
    {
      field: 'size',
      headerName: 'Size',
      description: 'File Size',
      width: 450
    }
  ];

  return (
    <>
      {ddpcrData?.length > 0 ?

        <div className="oneToolContainer flex flex-col h-[80dvh]">
          <h5 className="text-center pb-10 font-bold text-custom-green ">DDPCR Unprocessed Data</h5>
          <DataGrid columns={cols} rows={data} components={{
            Toolbar: GridToolbar
          }}>
          </DataGrid>
        </div> : ddpcrQuery?.isFetching ?
          <Spinner text="Fetching Data... Please wait" /> : ddpcrQuery?.isLoadingError ? <p>Sorry files could not be loaded ... loading error</p> : "No Unprocessed files found.."}



    </>
  )
}




export default ddPcrListUnprocessed;
